// extracted by mini-css-extract-plugin
export default {"country-flag-container":"top-product-properties_country-flag-container__jFfyg","update-time-icon":"top-product-properties_update-time-icon__R0kPs"};